import * as React from 'react';
import { createContext } from 'react';

import type { CampaignCannedCollectionModuleFragment } from 'bundles/campaigns/queries/__generated__/CannedCollectionModule';
import type { CampaignHeroModuleFragment } from 'bundles/campaigns/queries/__generated__/HeroModuleFragment';
import type { CampaignPromoBarModuleFragment } from 'bundles/campaigns/queries/__generated__/PromoBarModuleFragment';
import type { CampaignSpotlightCollectionsModuleFragment } from 'bundles/campaigns/queries/__generated__/SpotlightCollectionsModuleFragment';

type CampaignModulesDataContextType = {
  loading?: boolean;
  campaignData?: {
    heroModule?: CampaignHeroModuleFragment;
    collectionsModule?: CampaignSpotlightCollectionsModuleFragment;
    promoBarModule?: CampaignPromoBarModuleFragment;
    cannedCollectionModule?: CampaignCannedCollectionModuleFragment;
  };
};

const CampaignModulesDataContext = createContext<CampaignModulesDataContextType>({});

export const useCampaignModulesData = () => {
  return React.useContext(CampaignModulesDataContext);
};

export default CampaignModulesDataContext;
